import { render, staticRenderFns } from "./tareas.vue?vue&type=template&id=bb2b6c28"
import script from "./tareas.vue?vue&type=script&lang=js"
export * from "./tareas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports